export class ApiUrlConstants {

  public static SEPARATOR = '/';

  public static USERS = '/users';
  public static USERNAME_EXISTS = '/username/exists';
  public static USERS_EXTERNAL= '/external/users';
  public static USERS_SELF = ApiUrlConstants.USERS + '/self';
  public static USERS_SELF_GET = ApiUrlConstants.USERS + '-self';
  public static USERS_SELF_APPROVE_GDPR = ApiUrlConstants.USERS_SELF_GET + '/gdpr-approval';

  public static USERS_SELF_CHANGE_PASSWORD = ApiUrlConstants.USERS_SELF + '/password';
  public static USERS_STATUS = '/status';
  public static USERS_TECHNICAL = '/technicalUsers';

  public static ECONOMIC_OPERATORS = '/economic-operators';
  public static ECONOMIC_OPERATORS_EXTERNAL = '/external/economic-operators';
  public static ECONOMIC_OPERATORS_EXTERNAL_VALIDATE = ApiUrlConstants.ECONOMIC_OPERATORS_EXTERNAL + '/validate';
  public static ECONOMIC_OPERATORS_STATUS = '/status';
  public static ECONOMIC_OPERATORS_APPROVE = '/approve';
  public static ECONOMIC_OPERATOR_PENDING_APPROVALS = '/pending-approvals';
  public static EO_PERMISSION = '/eo-permission';
  public static EO_TREEMAP = '/treemap';

  public static FACILITIES = '/facilities';
  public static FACILITIES_STATUS = '/status';

  public static MACHINES = '/machines';
  public static MACHINES_STATUS = '/status';

  public static ORDERS = '/orders';
  public static ORDERS_UID_FILE_PREFIX = ApiUrlConstants.ORDERS + ApiUrlConstants.SEPARATOR;
  public static ORDERS_UID_FILE_SUFFIX = '/codes/file';
  public static ORDERS_SUBUNIT_UID_FILE_SUFFIX = '/subunit/codes/file';


  public static ORDERS_UNIT = ApiUrlConstants.ORDERS + '/unit';
  public static ORDERS_AGGREGATED = ApiUrlConstants.ORDERS + '/aggregated';
  public static ORDERS_SUBUNIT = ApiUrlConstants.ORDERS + '/subunit';
  public static ORDERS_CANCEL_SUFFIX = '/cancel';
  public static ORDERS_APPROVE_SUFFIX = '/approve';

  public static TAX_LEVELS = '/taxes';
  public static TAX_REPORTS = '/tax-consumer/tax-reports';

  public static APPROVE = '/approve';

  public static CHANGE_LOGS = '/changes';

  public static CHANGE_PASSWORD_REQUEST = '/reset-password';
  public static CHANGE_PASSWORD_TOKEN = ApiUrlConstants.CHANGE_PASSWORD_REQUEST + '/validate';
  public static CHANGE_PASSWORD = ApiUrlConstants.CHANGE_PASSWORD_REQUEST + '/change';

  public static DASHBOARD_METRICS = '/metrics';
  public static PRODUCTS = '/products';
  public static STAMPS = '/stamps';
  public static IMAGE = '/image';
  public static LOCAL = '/local';
  public static EXPORT = '/export';
  public static PRODUCTS_WITH_IMAGE = '/with-image';
  public static PRODUCTS_PENDING_APPROVAL = '/pending-approvals';
  public static PRODUCT_EOID = '/eoid';
  public static EO_UIDS = '/eoUids';
  public static FACILITY_UIDS = '/facilityUids';
  public static PRODUCT_CUSTOMER_IDS = '/customerIds';
  public static PRODUCT_EXCEPT = '/except';
  public static PRODUCT_STATUS = '/status';
  public static PRODUCT_DOMAINS = '/domains';
  public static PRODUCT_DOMAINS_TYPES = ApiUrlConstants.PRODUCT_DOMAINS + '/product-types';
  public static PRODUCT_TYPES ='/product-types';
  public static PRODUCT_TYPES_BY_TAX_LEVEL = '/by-tax-level';
  public static PRODUCT_TYPE = 'product-type';
  public static PRODUCT_TYPES_BY_DOMAINS = '/by-domains';
  public static PRODUCT_TYPE_HIERARCHY='product-type-hierarchy'
  public static PRODUCT_TYPES_TAX_LEVEL_UPDATE = ApiUrlConstants.PRODUCT_DOMAINS + '/product-types-tax-level';
  public static DYNAMIC_PRODUCT_FORM_CONFIG = '/dynamic-product-form/config';

  public static PRODUCTION_REQUESTS = '/production-requests';
  public static PENDING_PRODUCTION_REQUEST_APPROVAL = '/pending-production-request/approval';
  public static PRODUCTION_REQUESTS_FOLLOWUP = ApiUrlConstants.PRODUCTION_REQUESTS + '/followup';
  public static REMAINING = ApiUrlConstants.PRODUCTION_REQUESTS +'/remaining';

  public static EXCISE_WAREHOUSES = '/excise-warehouses';

  public static REPORTING = '/reporting';
  public static REPORTING_FILE = ApiUrlConstants.REPORTING + '/file';

  public static ADVANCED_REPORTING = '/advanced-reporting';
  public static ADVANCED_REPORTING_ENTITY_HISTORY = ApiUrlConstants.ADVANCED_REPORTING + '/entity-history';
  public static ADVANCED_REPORTING_ORDER_HISTORY = ApiUrlConstants.ADVANCED_REPORTING + '/order-history';
  public static ADVANCED_REPORTING_EO_EXPORT = ApiUrlConstants.ADVANCED_REPORTING + '/export/eo';
  public static ADVANCED_REPORTING_FACILITY_EXPORT = ApiUrlConstants.ADVANCED_REPORTING + '/export/facility';
  public static ADVANCED_REPORTING_ORDERS_EXPORT = ApiUrlConstants.ADVANCED_REPORTING + '/export/orders';
  public static ADVANCED_REPORTING_ROUTER_CHECK = ApiUrlConstants.ADVANCED_REPORTING + '/router-check';
  public static ADVANCED_REPORTING_STATISTICS = ApiUrlConstants.ADVANCED_REPORTING + '/statistics';
  public static ADVANCED_REPORTING_ROUTE_STATISTICS = ApiUrlConstants.ADVANCED_REPORTING + '/route-statistics';
  public static ADVANCED_REPORTING_PRODUCTION_REQUEST_HISTORY = ApiUrlConstants.ADVANCED_REPORTING + '/production-request-history';
  public static ADVANCED_REPORTING_TAX_REPORTS = ApiUrlConstants.ADVANCED_REPORTING + '/tax-reports';

  public static SETTINGS_WORKING_DAYS = '/config/workingDays';

  public static SAGA_BUSINESS_LOCATIONS = '/saga/businessLocations';
  public static SAGA_EVENTS = '/saga/events';
  public static SAGA_POST_EVENT = '/saga/insertEpcisDocument';

  public static CHECK_UI = '/check?eStamps=';

  public static CONTACT_US = '/contact-us';
  public static CONTACTU_US_EXTERNAL = '/external/contact-us';

  public static LOGIN = '/login';
  public static LOGOUT = '/logout';
  public static REFRESH = '/refresh';

  public static STORE = '/store';
  public static STORE_MESSAGES = ApiUrlConstants.STORE + '/messages';

  public static getPermitAllUrl(): any[] {
    return [
      {url: ApiUrlConstants.LOGIN},
      {url: ApiUrlConstants.REFRESH},
      {url: ApiUrlConstants.CHANGE_PASSWORD_REQUEST},
      {url: ApiUrlConstants.CHANGE_PASSWORD_TOKEN},
      {url: ApiUrlConstants.CHANGE_PASSWORD},
      {url: ApiUrlConstants.ECONOMIC_OPERATORS_EXTERNAL},
      {url: ApiUrlConstants.ECONOMIC_OPERATORS_EXTERNAL_VALIDATE},
      {url: ApiUrlConstants.CONTACTU_US_EXTERNAL},
      {url: ApiUrlConstants.PRODUCT_DOMAINS},
      {url: ApiUrlConstants.USERS_EXTERNAL}
    ];
  }
}

export class ApiParamConstants {

  public static PERMISSION = 'permissionType';
  public static EOID = 'eoId';
  public static EO_CODE = 'eoCode';
  public static FACILITY_ID = 'facilityId';
  public static ORDER_ID = 'orderId';
  public static LIST_PAGE = 'page';
  public static LIST_PAGE_SIZE = 'size';
  public static LIST_SORT = 'sort';
  public static LIST_KEYWORD = 'keyword';
  public static LIST_COUNTRIES = 'countryReg';
  public static LIST_ACTIVATED = 'activated';
  public static LIST_ENTITY_STATUS = 'entityStatus';
  public static LIST_TYPE = 'type';
  public static LIST_STATUS = 'status';
  public static LIST_DIRECTLY_LINKED_ONLY = 'directlyLinkedOnly';
  public static LIST_CAN_REQUEST_UID = 'canRequestUid';
  public static LIST_BLOCKED = 'blocked';
  public static LIST_STRICT_SEARCH = 'strictSearch';
  public static LIST_FUZZY_DISABLED = 'disableFuzzySearch';
  public static LIST_EO_RELIABLE = 'reliable';
  public static LIST_EO_CAN_ORDER_UID = 'canRequestUid';
  public static LIST_EO_REG_EOID = 'regEoid';
  public static LIST_ORDER_TYPE = 'orderType';
  public static LIST_ORDER_INTENDED_MARKET = 'intendedMarket';
  public static LIST_ORDER_PRODUCT_TYPE = 'orderProductType';
  public static LIST_ORDER_PHYSICAL_DELIVERY = 'orderPhysicalDelivery';
  public static LIST_ORDER_OVERDUE_TARGET_DATE = 'overdueTargetDate';
  public static LIST_ORDER_NO_CANCELATION = 'noCancelation';
  public static LIST_PRODUCT_TYPE_ID = 'productTypeId';
  public static LIST_PRODUCT_TYPE_IDS = 'productTypeIds';
  public static RESET_PASSWORD_ID = 'id';
  public static RESET_PASSWORD_TOKEN = 'token';
  public static REPORTING_GROUP_BY = 'groupBy';
  public static REPORTING_ORDER_STATUS = 'orderStatus';
  public static REPORTING_FROM = 'from';
  public static REPORTING_TO = 'to';
  public static REPORTING_EOID = 'eoid';
  public static REPORTING_FID = 'fid';
  public static REPORTING_MID = 'mid';
  public static PRODUCT_ID = 'productId';
  public static PRODUCT_IDS = 'productIds';
  public static REPORTING_YEAR = 'year';
  public static REPORTING_MONTH = 'month';
  public static REPORTING_NUMBER_OF_RESULTS = 'numberOfResults';
  public static VALIDATE_EXTERNAL_EO_TOKEN = 'token';
  public static PRODUCT_TYPES_INACTIVE = 'inactive';
  public static PRODUCT_TYPES_DOMAIN_ID = 'domainId';
  public static PRODUCT_DOMAIN_IDS = 'productDomainIds';
  public static PRODUCT_TYPES_SHOW_EMPTY_DOMAINS = 'showEmptyDomains';
  public static PRODUCT_TYPES_TAX_LEVEL_ID = 'taxLevelId';
  public static LIST_ECONOMIC_OPERATORS_PRODUCTS_APPROVED = 'productsApproved';
  public static PRODUCT_APPROVED = 'approved';
  public static PRODUCT_COMMENT = 'comment';
  public static PRODUCT_STATUS = 'productStatus';
  public static PRODUCTION_REQUEST_MONTH = 'month';
  public static FACILITY_EXCISE_WAREHOUSE = 'exciseWarehouse';
  public static EXCISE_WAREHOUSE_EO_APPROVED = 'eoApproved';
  public static EXCISE_WAREHOUSE_AUTHORITY_NOT_APPROVED = 'authorityNotApproved';
  public static EXCISE_WAREHOUSE_LATE_VALIDATION = 'lateValidation';
  public static EOS_DOMAIN_ID = 'eosDomainId';
  public static IS_PAGEABLE = 'isPageable';
}